import { Clock } from "lucide-react";

const TopBanner = () => {
  return (
    <div className="bg-accent py-2 md:py-3 text-center accent-banner">
      <div className="container flex items-center justify-center gap-2">
        <Clock className="w-4 h-4 text-accent-foreground" aria-hidden="true" />
        <span className="text-accent-foreground font-semibold text-sm md:text-base">
          Hurry! 75% OFF – Limited Time Only!
        </span>
      </div>
    </div>
  );
};

export default TopBanner;
